import { render, staticRenderFns } from "./Juhe.vue?vue&type=template&id=db70daec&scoped=true&"
import script from "./Juhe.vue?vue&type=script&lang=js&"
export * from "./Juhe.vue?vue&type=script&lang=js&"
import style0 from "./Juhe.vue?vue&type=style&index=0&id=db70daec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db70daec",
  null
  
)

export default component.exports